import React, { useEffect, useState} from 'react';

const ErrorBoundary = ({ children, stepperFunc, steps, stepObj }) => {
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleError = (error) => {
      setError(error);
      console.error('Error caught by boundary:', error);
    };
    window.addEventListener('error', handleError);

    return () => {
      window.removeEventListener('error', handleError);
    };
  }, []);

  useEffect(() => {
    if (error && stepperFunc) {
      let goTo = 0; // Default to step 0
      
      try {
        // First, check if we have a valid currentStep in sessionStorage
        const currentStep = sessionStorage.getItem('currentStep');
        
        if (currentStep) {
          const parsedStep = parseInt(currentStep);
          
          // Check if currentStep is a valid number
          if (!isNaN(parsedStep)) {
            // If we have a valid currentStep, try to find an error step in stepObj
            if (stepObj && typeof stepObj === 'object' && Object.keys(stepObj).length > 0) {
              const reversed = Object.keys(stepObj).map(Number);
              const errorStep = reversed.find((key) =>
                stepObj[key] && stepObj[key].includes("error")
              );
              
              // If error step is found, use it; otherwise use currentStep
              if (errorStep !== undefined) {
                goTo = errorStep;
              } else {
                goTo = parsedStep;
              }
            } else {
              // No stepObj, use currentStep
              goTo = parsedStep;
            }
          } else {
            // Invalid currentStep, default to step 0
            goTo = 0;
          }
        } else {
          // No currentStep in sessionStorage, default to step 0
          goTo = 0;
        }
      } catch (e) {
        // If any error occurs in the logic, default to step 0
        goTo = 0;
      }
      
      // Navigate to the determined step
      stepperFunc(goTo);
      
      // Clear the error after navigation
      setError(null);
    }
  }, [error, stepperFunc, stepObj]);

  return children;
};

export default ErrorBoundary;